import { FontSizes } from '@fluentui/react';

import type { IH2OTheme } from '../../../../models/components.models';
import { mediaMobile, mediaNoMobile } from '../../../../utils/styles';
import { showElements } from '../../AppBarNavigation.styles';
import type { NavigationElementsStyles } from './types';

export const navigationElementsStyles = (theme: IH2OTheme): NavigationElementsStyles => ({
  root: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    ...mediaNoMobile({
      fontSize: FontSizes.medium,
      lineHeight: FontSizes.large,
    }),
    ...mediaMobile({
      fontSize: FontSizes.mediumPlus,
      lineHeight: FontSizes.large,
    }),
  },
  element: {
    padding: '0 8px',
    ':not(:last-child)': { marginBottom: -4 },

    ':hover': {
      '> a.element-wrapper, > .h2o-ButtonContainer-root.element-wrapper': {
        background: `linear-gradient(130deg, ${theme.semanticColors?.buttonPrimaryHoverBackground} 1.77%, ${theme.semanticColors?.buttonPrimaryBackground} 100%)`,
        color: theme.palette?.textOverPrimary,
      },
      '> .element-wrapper svg *': { stroke: theme.palette?.textOverPrimary },
      '> .element-wrapper svg.nav-icon-fill *': { fill: theme.palette?.textOverPrimary },
    },

    ':not(.element-active)': {},
    ':not(.element-active):hover': {
      '> .h2o-NavigationSection-root, > .h2o-NavigationSection-root:not(.section-active)': {
        opacity: 1,
        transform: 'translateX(0)',
        boxShadow: `2px 3px 5px 0px rgba(0, 0, 0, 0.08)`,
      },
      '.h2o-NavigationElements-elementTitle, .h2o-NavigationElementsMore-root, .h2o-NavigationBlocks-title': {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },

    '&.element-active': {
      '&.element-with-image > .element-wrapper': {
        background: `linear-gradient(130deg, ${theme.semanticColors?.buttonPrimaryHoverBackground} 1.77%, ${theme.semanticColors?.buttonPrimaryBackground} 100%)`,
      },
      '> .element-wrapper': {
        background: `linear-gradient(130deg, ${theme.semanticColors?.buttonPrimaryHoverBackground} 1.77%, ${theme.semanticColors?.buttonPrimaryBackground} 100%) !important`,
        color: theme.palette?.textOverPrimary,
      },
      '> .element-wrapper svg *': { stroke: theme.palette?.textOverPrimary },
      '> .element-wrapper svg.nav-icon-fill *': { fill: theme.palette?.textOverPrimary },
      '> .h2o-NavigationSection-root': {
        zIndex: -3,
        '.h2o-NavigationElements-elementTitle, .h2o-NavigationElementsMore-root, .h2o-NavigationBlocks-title': {
          ...showElements,
        },
      },
    },
    '&.element-active:hover': {
      '> .h2o-NavigationSection-root': {
        ...mediaNoMobile({
          opacity: '1 !important',
          transform: 'translateX(0) !important',
        }),
      },
    },

    // A row carrying a trailing control is the positioning context for it, and reserves room so a
    // long name ellipsizes short of the control instead of running under it. Scoped to those rows,
    // so every other nav row keeps its geometry.
    '&.element-has-trailing': {
      position: 'relative',
      '> .element-wrapper': { paddingRight: 32 },
    },

    '&.element-disabled': {
      pointerEvents: 'none !important',
      '*': { color: `${theme.palette?.gray400} !important` },
    },

    '.element-wrapper': {
      display: 'flex',
      alignItems: 'center',
      borderRadius: 4,
      textDecoration: 'none',
      transition: 'opacity .2s, background .2s',
      ...mediaNoMobile({ padding: 8 }),
      ...mediaMobile({ padding: '12px 8px' }),
    },
    '.Link-text': {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
    },
    'div.element-wrapper': { padding: 0 },
    'a.element-wrapper': { color: theme.palette?.gray700 },
    'button.element-wrapper': {
      minHeight: 0,
      height: 'auto',
      lineHeight: 18,
      color: 'inherit',
    },
  },
  elementImage: {
    marginRight: 8,
    lineHeight: 0,
    minWidth: 24,
    transition: 'transform .2s',
    i: { lineHeight: '1' },
  },
  elementTitle: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    transition: 'transform .2s, opacity .2s',
  },
});
